export const EXISTS = "EXISTS";
export const NOTEXISTS = "NOTEXISTS";

export const BoxSetNumber = 9999;